import type { GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile from "./default";
import { commonMenuItems } from "./common";
import { i18n } from "@/i18n";

const { t } = i18n.global;

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/saleblazers_wiki/link"), "_blank", "noopener,noreferrer");
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "branch" } },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "game_options" } },
  { component: "ConfSection", props: { name: "game_options_exploration_and_combat" } },
  { component: "ConfSection", props: { name: "game_options_shopkeeping" } },
  { component: "ConfSection", props: { name: "game_options_survival" } },
  { component: "ConfSection", props: { name: "global_permission_config" } },
  { component: "ConfSection", props: { name: "area_permission_config" } },
  { component: "TableSection", props: { name: "adminList" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/saleblazers_wiki",
    joinFn: join,
  },
});
